import { FileInfo, FileState } from '@progress/kendo-angular-upload';

const dataUrlToFile = (dataUrl: string, fileName: string): File => {
  // Extract the base64 part from the data URL
  const [header, base64Data] = dataUrl.split(',');
  const mimeType = header.match(/:(.*?);/)?.[1] || 'application/octet-stream';

  // Decode base64 to binary data
  const binaryString = atob(base64Data);
  const byteArray = new Uint8Array(binaryString.length);

  for (let i = 0; i < binaryString.length; i++) {
    byteArray[i] = binaryString.charCodeAt(i);
  }

  // Create a Blob and then convert it to a File
  const blob = new Blob([byteArray], { type: mimeType });
  return new File([blob], fileName, { type: mimeType });

  // return new File([byteArray], fileName, { type: mimeType });
};

const fileToFileInfo = (file: File): FileInfo => {
  return {
    rawFile: file, // The original File object
    name: file.name, // File name
    size: file.size, // File size in bytes
    extension: `.${file.name.split('.').pop()}`, // File extension
    state: FileState.Selected, // Default state for newly selected files
    uid: `${Date.now()}-${Math.random()}`, // Unique ID for the file
  };
};

const getDeviceAspectRatio = (): { width: number; height: number } => {
  const width = window.innerWidth;
  const height = window.innerHeight;
  return { width: width, height: height };

  // const gcd = (a: number, b: number): number => (b === 0 ? a : gcd(b, a % b)); // Helper function to calculate the GCD
  //
  // const divisor = gcd(width, height);
  // return `${width / divisor}:${height / divisor}`;
};
export { dataUrlToFile, fileToFileInfo, getDeviceAspectRatio };
